import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Mail, Phone, MapPin, ExternalLink } from "lucide-react";
import SEO from "@/components/SEO";

// Stand 14.10.2026 (Sitzung „Aufräumen“, Frage 298): § 5 DDG statt TMG, § 18 MStV statt RStV, ohne Link auf die
// abgeschaltete EU-Plattform zur Online-Streitbeilegung, Streitbeilegung wie in den AGB (Abschnitt 14). Text von
// Claude, Prüfung durch Daniel oder die Anwältin.
const Impressum = () => {
  return (
    <div className="min-h-screen">
      <SEO title={`Impressum | MusiKonzept`} description={`Impressum von MusiKonzept – Anbieterkennzeichnung, Kontakt und gesetzliche Angaben gemäß § 5 DDG.`} path="/impressum" />
      <Header />
      <main className="pt-20">
        <div className="container mx-auto px-6 py-16 max-w-4xl">
          <h1 className="text-4xl font-bold text-primary mb-8">Impressum</h1>

          <div className="space-y-8">
            {/* Kontaktdaten */}
            <section className="bg-card/40 backdrop-blur-xl border-0 rounded-xl p-8 space-y-4">
              <h2 className="text-2xl font-bold text-foreground mb-6">Angaben gemäß § 5 DDG</h2>

              <div className="space-y-3">
                <div>
                  <p className="text-lg font-semibold text-foreground">Daniel Sommer</p>
                  <p className="text-muted-foreground">MusiKonzept</p>
                </div>

                <div className="flex items-start gap-3 text-muted-foreground">
                  <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0 text-primary" />
                  <div>
                    <p>Lanker Straße 10</p>
                    <p>40545 Düsseldorf</p>
                    <p>Deutschland</p>
                  </div>
                </div>

                <div className="flex items-center gap-3 text-muted-foreground">
                  <Phone className="h-5 w-5 flex-shrink-0 text-primary" />
                  <a href="tel:+4921133676286" className="hover:text-primary transition-colors">
                    0211 33676286
                  </a>
                </div>

                <div className="flex items-center gap-3 text-muted-foreground">
                  <Mail className="h-5 w-5 flex-shrink-0 text-primary" />
                  <a href="mailto:info@musikonzept.de" className="hover:text-primary transition-colors">
                    info@musikonzept.de
                  </a>
                </div>
              </div>
            </section>

            {/* Verantwortlich */}
            <section className="bg-card/40 backdrop-blur-xl border-0 rounded-xl p-8 space-y-4">
              <h2 className="text-2xl font-bold text-foreground mb-4">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
              <div className="text-muted-foreground">
                <p>Daniel Sommer</p>
                <p>Lanker Straße 10</p>
                <p>40545 Düsseldorf</p>
              </div>
            </section>

            {/* Verbraucherstreitbeilegung */}
            <section className="bg-card/40 backdrop-blur-xl border-0 rounded-xl p-8 space-y-4">
              <h2 className="text-2xl font-bold text-foreground mb-4">Verbraucherstreitbeilegung</h2>
              <p className="text-muted-foreground leading-relaxed">
                MusiKonzept ist weder verpflichtet noch bereit, an einem Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            {/* Fairness im Handel */}
            <section className="bg-card/40 backdrop-blur-xl border-0 rounded-xl p-8 space-y-4">
              <h2 className="text-2xl font-bold text-foreground mb-4">Fairness im Handel</h2>
              <p className="text-muted-foreground leading-relaxed">
                Mitglied der Initiative „Fairness im Handel". Nähere Informationen:{" "}
                <a
                  href="https://www.fairness-im-handel.de"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:underline inline-flex items-center gap-1"
                >
                  https://www.fairness-im-handel.de
                  <ExternalLink className="h-4 w-4" />
                </a>
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Impressum;
